export const fileTypes = {
  0: 'web',
  1: 'video',
  2: 'audio',
  3: 'image',
  4: 'game_app',
  5: 'document',
  6: 'presentation',
  7: 'simulation'
}

export const applicationFlags = {
  displayArtifactSize: 'qw_display_artifact_sizes',
  displaySchedules: 'qw_show_schedules',
  displayEstimatedJourneyCompletionDate:
    'qw_enable_estimated_journey_completion',
  displayTermReports: 'qw_enable_term_reports',
  studentLocationByDefaultRemote: 'qw_default_student_location_to_remote',
  enableMentorLoomRecording: 'qw_enable_loom_recording',
  enableStudentLoomRecording: 'qw_enable_student_loom_recording',
  enableRequiredSkillsChecks: 'qw_enable_student_required_skills_checks',
  hideStudentPerformanceTab: 'qw_hide_performance_tab',
  hideMentorViewPerformanceTab: 'qw_hide_mentor_view_performance_tab',
  enableMentorsOverrideCheckpoints: 'qw_enable_mentors_override_activity_checkpoints'
}

export const myStudentsDisplayLevelView = {
  overview: 'Overview',
  targetDate: 'Target Dates',
  assessments: 'Assessments'
}

export const COMPONENT_SIZE = {
  SMALL: 0,
  MEDIUM: 1,
  LARGE: 2
}

export const NOTE_VISIBILITY = Object.freeze({
  PRIVATE: 'creator',
  SHARED: 'mentors'
})

export const SKILL_CHECK_MAX_RATING = 4
